module.exports = __webpack_public_path__ + "img/banner-princiapal.3819c790.png";